import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const TemplatesList = Loadable(
	lazy(() =>
		import("./TemplatesList").then(({ TemplatesList }) => ({
			default: TemplatesList,
		}))
	)
);

const MessagingTemplate = Loadable(
	lazy(() =>
		import("./Template").then(({ MessagingTemplate }) => ({
			default: MessagingTemplate,
		}))
	)
);

export const templateRoutes = [
	{
		path: "/templates",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.TEMPLATES]}
			>
				<TemplatesList />
			</AuthorizedRoute>
		),
	},

	{
		path: "/templates/manage-template",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.TEMPLATES]}
			>
				<MessagingTemplate />
			</AuthorizedRoute>
		),
	},
	{
		path: "/templates/manage-template/:templateCode",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.TEMPLATES]}
			>
				<MessagingTemplate />
			</AuthorizedRoute>
		),
	},
];
